import React, { Component } from 'react';
import {
  Button,
  Checkbox,
  DropdownButton,
  ControlLabel,
  Form,
  MenuItem,
  FormControl,
  FormGroup,
} from 'react-bootstrap';

import moment from 'moment';

import './App.css';
import ItemSearch from './ItemSearch';
import ReceptionistNav from './ReceptionistNav';
import firebase from './firebase';
import model from './Model';

import closeIcon from './img/icon/icon_close.svg';
import moveBackIcon from './img/icon/icon_back.svg';
import moveNextIcon from './img/icon/icon_next.svg';

const MAX_LIVE_STREAMING_SECONDS = 7200;
const MAX_CTA_ITEMS = 4;

const ENABLE_CHAT = false;
const ENABLE_CTA = false;
const ENABLE_ROTATION = false;

const OT = window.OT;
const db = firebase.firestore();

export default class Reception extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOffline: false,
      isPublishing: false,
      isSubscribing: false,
      isLive: false,
      isVolumeOn: true,
      isMicrophoneOn: true,
      rotated: false,
      shopIndex: 0,
      shops: [],
      liveItems: [],
      calls: [],
      reception: null,
      healthCheckIntervalId: null,
      intervalId: null,
      elapsedTime: 0,
      comments: [],
      receptionistName: '',
      receptionistText: ''
    };
  }

  componentDidMount() {
    Notification.requestPermission()
  
    this.setupHardwareDevice();
    this.startCheckConnectionState();

    const uid = firebase.auth().currentUser.uid;
    db.collection('receptionists').doc(uid).get().then((querySnapshot) => {
      if(!querySnapshot.exists) {
        return;
      }
      this.setState({ receptionistName: querySnapshot.data().name })
    })
    db.collection('receptionists').doc(uid).collection('shops').get().then((querySnapshot) => {
      const promises = querySnapshot.docs.map((queryDocumentSnapshot) => {
        return db.collection('shops').doc(queryDocumentSnapshot.id).get().then((documentSnapshot) => {
          return documentSnapshot.data();
        })
      });
      Promise.all(promises).then((shops) => {
        this.setState({ shops });
        const from = firebase.firestore.Timestamp.fromDate(moment().subtract(5, 'minute').toDate());
        const query = db.collection('calls').where('calling', '==', true).orderBy('created', 'asc').startAt(from);
        const shopIds = shops.map((shop) => shop.id);
        this.offCalls = query.onSnapshot((querySnapshot) => {
          const calls = querySnapshot.docs.map((doc) => doc.data()).filter((call) => shopIds.includes(call.shopId));
          this.setState({ calls });
          this.setNotification();
        });
      });
    });

    window.addEventListener('beforeunload', this.confirmUnload);
    window.addEventListener('unload', this.unpublish);
  }

  componentWillUnmount() {
    this.stopCheckConnectionState();

    if (this.offCall) {
      this.offCall();
    }

    if (this.offCalls) {
      this.offCalls();
    }

    window.removeEventListener('beforeunload', this.confirmUnload);
    window.removeEventListener('unload', this.unpublish);
  }

  setNotification() {
    const { calls, isPublishing, isLive } = this.state;
    if (isPublishing && !isLive) {
      new Notification(`現在、待機中のお客様が${calls.length}人です`);
    }
  }

  setupHardwareDevice() {
    if (this.otHardwareSetup) {
      return;
    }
    const element = document.querySelector('#hardware-setup');
    this.otHardwareSetup = window.createOpentokHardwareSetupComponent(element, {
      insertMode: 'append'
    }, (error) => {
      if (error) {
        console.error('Error: ', error);
        document.querySelector('#hardware-setup').innerHTML = `
          <strong>エラー：デバイス選択できません</strong>: ${error.message}
        `;
      }
    });
  }

  async checkReception() {
    const waitingReceptionDoc = await db
      .collection('receptions')
      .where('uid',  '==', firebase.auth().currentUser.uid)
      .where('waiting', '==', true)
      .orderBy('touched', 'asc')
      .startAt(firebase.firestore.Timestamp.fromDate(moment().subtract(1, 'minute').toDate()))
      .get();

    const liveReceptionDoc = await db
      .collection('receptions')
      .where('uid',  '==', firebase.auth().currentUser.uid)
      .where('live', '==', true)
      .orderBy('touched', 'asc')
      .startAt(firebase.firestore.Timestamp.fromDate(moment().subtract(1, 'minute').toDate()))
      .get();
    return [...waitingReceptionDoc.docs, ...liveReceptionDoc.docs].length > 0
  }

  async publish() {
    const {
      isPublishing,
      isMicrophoneOn,
      rotated,
      shops,
    } = this.state;

    if (isPublishing) {
      return;
    }
    if (await this.checkReception()) {
      alert('他の端末で同じアカウントにてレセプション機能をご利用中です。');
      return;
    }

    this.setState({ isLoading: true });

    if (this.otHardwareSetup) {
      this.otAudioSource = this.otHardwareSetup.audioSource();
      this.otVideoSource = this.otHardwareSetup.videoSource();
      this.otHardwareSetup.destroy();
      this.otHardwareSetup = null;
    }

    this.otPublisher = await OT.initPublisher('publisher', {
      insertMode: 'append',
      resolution: '1280x720',
      height: rotated ? 405 : 720,
      width: rotated ? 720 : 405,
      frameRate: 30,
      audioFallbackEnabled: false,
      mirror: false,
      audioSource: this.otAudioSource,
      videoSource: this.otVideoSource,
      publishAudio: isMicrophoneOn,
      publishVideo: true,
      showControls: false,
    });
    this.otPublisher.on('streamDestroyed', async (event) => {
      if (event.reason === 'networkDisconnected') {
        window.alert('ネットワークの切断によりレセプションが終了しました');
        await this.endReception();
      }
    });
    const response = await model.fetch('publishSession');
    const data = await response.json();
    this.otSession = OT.initSession(data.apiKey, data.sessionId, {
      connectionEventsSuppressed: true,
    });
    this.otSession.connect(data.token, (error) => {
      if (error) {
        console.error(error);
        this.setState({ isLoading: false });
      } else {
        this.otSession.publish(this.otPublisher, (error) => {
          if (error) {
            console.error(error);
            this.setState({ isLoading: false });
          } else {
            const receptionDocRef = db.collection('receptions').doc();
            receptionDocRef.set({
              created: firebase.firestore.FieldValue.serverTimestamp(),
              touched: firebase.firestore.FieldValue.serverTimestamp(),
              uid: firebase.auth().currentUser.uid,
              receptionId: receptionDocRef.id,
              sessionId: this.otSession.sessionId,
              shopIds: shops.map((shop) => shop.id),
              rotated,
              waiting: true,
            });
            receptionDocRef.get().then((doc) => {
              const reception = doc.data();
              const healthCheckIntervalId = setInterval(() => {
                receptionDocRef.update({
                  touched: firebase.firestore.FieldValue.serverTimestamp(),
                });
              }, 1 * 60 * 1000);
              this.setState({ isLoading: false, isPublishing: true, reception, healthCheckIntervalId });

              const CommentRef = db.collection('receptions').doc(reception.receptionId).collection('comments').orderBy('created', 'desc').limit(10);
              this.offComment = CommentRef.onSnapshot((commentSnapshot) => {
                const comments = commentSnapshot.docs.map((commentSnapshot) => commentSnapshot.data());
                this.setState({ comments: comments.filter((comment) => !!comment.created) });
              });
            });
          }
        });
      }
    });
  }

  async unpublish() {
    const {
      isPublishing,
      isLive,
      reception,
      healthCheckIntervalId,
    } = this.state;

    if (!isPublishing) {
      return;
    }

    if (reception) {
      if (isLive) {
        await model.fetch(`archiveStop?archiveId=${reception.archiveId}`);
      }

      if (reception.waiting) {
        await db.collection('receptions').doc(reception.receptionId).update({ waiting: false });
      }
    }

    if (healthCheckIntervalId) {
      clearInterval(healthCheckIntervalId);
    }

    if (this.otPublisher && this.otSession) {
      this.otSession.unpublish(this.otPublisher);
      this.otSession.disconnect();
    }

    this.stopCountUp();

    this.setState({
      isPublishing: false,
      isLive: false,
      reception: null,
      healthCheckIntervalId: null,
    });
  };

  async subscribe(sessionId) {
    const { isVolumeOn } = this.state;
    const response = await model.fetch(`subscribe?sessionId=${sessionId}`, 'POST');
    const data = await response.json();
    this.otSubscribeSession = OT.initSession(data.apiKey, sessionId);
    this.otSubscribeSession.on('streamCreated', (event) => {
      this.otSubscriber = this.otSubscribeSession.subscribe(event.stream, {
        insertDefaultUI: false,
        videoSource: false,
        audioVolume: isVolumeOn ? 100 : 0,
      },
      (error) => {
        if (error) {
          console.error(error);
        }
      });
      this.setState({ isSubscribing: true });
    });
    this.otSubscribeSession.on('streamDestroyed', (event) => {
      this.setState({ isSubscribing: false });
    });
    this.otSubscribeSession.connect(data.token, (error) => {
      if (error) {
        console.error(error);
      }
    });
  }

  closePreview() {
    if (window.confirm('プレビューを終了します。よろしいですか？')) {
      this.unpublish();
      this.setupHardwareDevice();
    }
  }

  async startReception() {
    const {
      isLive,
      reception,
      liveItems,
      calls,
    } = this.state;

    if (isLive) {
      return;
    }

    const response = await model.fetch('archiveStart', 'POST', { sessionId: this.otSession.sessionId });
    const archive = await response.json();

    const uid = firebase.auth().currentUser.uid;
    const ctaEvents = liveItems.filter(item => item.cta).map(item => {
      return {
        created: firebase.firestore.FieldValue.serverTimestamp(),
        display: item.cta,
        itemId: item.id,
        uid,
      };
    });
    for (var i = 0; i < calls.length; i += 1) {
      const call = calls[i];
      const receptionDocRef = db.collection('receptions').doc(reception.receptionId);
      await receptionDocRef.update({
        started: firebase.firestore.FieldValue.serverTimestamp(),
        callId: call.callId,
        archiveId: archive.id,
        waiting: false,
        live: true,
        liveItems,
      });
      ctaEvents.forEach((ctaEvent) => receptionDocRef.collection('cta-events').add(ctaEvent));
      this.setState({
        isLive: true,
        reception: (await receptionDocRef.get()).data(),
      });
      this.offCall = db.collection('calls').doc(call.callId).onSnapshot((querySnapshot) => {
        const call = querySnapshot.data();
        if (call) this.setState({ call });
        if (call && call.closed) {
          window.alert('お客様の切断によりレセプションが終了しました');
          this.endReception();
        }
      });
      await this.subscribe(call.sessionId);
      break;
    }

    this.startCountUp();
  }

  async endReception() {
    const {
      isLive,
      reception,
    } = this.state;

    if (!isLive) {
      return;
    }

    this.setState({
      isLive: false,
      reception: null,
    });

    if (this.offCall) {
      this.offCall();
      this.offCall = null;
    }

    if (this.offComment) {
      this.offComment();
      this.offComment = null;
    }

    if (reception) {
      try {
        await model.fetch(`archiveStop?archiveId=${reception.archiveId}`);
      } catch (error) {
        console.error(error);
      }

      if (reception.waiting || reception.live) {
        await db.collection('receptions').doc(reception.receptionId).update({ waiting: false, live: false });
      }
    }

    this.stopCountUp();

    await this.unpublish();
    await this.publish();
  }

  startCheckConnectionState() {
    this.stopCheckConnectionState();
    this.checkConnectionStateId = setInterval(() => this.checkConnectionState(), 1000);
  }

  stopCheckConnectionState() {
    if (this.checkConnectionStateId) {
      clearInterval(this.checkConnectionStateId);
    }
  }

  async checkConnectionState() {
    const { isLive, call } = this.state;
    if (isLive && call && call.touched && moment().diff(moment(call.touched.toDate()), 'seconds') > 30) {
      await this.endReception();
      window.alert('お客様の切断によりレセプションが終了しました');
    }
    firebase.database().ref('.info/connected').on('value', (snap) => {
      if (this.state.isOffline === null) {
        this.setState({ isOffline: false });
      } else {
        this.setState({ isOffline: !snap.val() });
      }
    });
  }

  startCountUp() {
    this.stopCountUp();
    this.setState({ intervalId: setInterval(() => this.tickCountUp(), 1000) });
  }

  stopCountUp() {
    const { intervalId } = this.state;
    if (!intervalId) {
      return;
    }

    clearInterval(intervalId);
    this.setState({ intervalId: null, elapsedTime: 0 });
  }

  tickCountUp() {
    let { elapsedTime } = this.state;
    if (++elapsedTime === MAX_LIVE_STREAMING_SECONDS) {
      this.stopCountUp();
      this.unpublish();
      window.alert('レセプションは終了しました');
      this.setupHardwareDevice();
    } else {
      this.setState({ elapsedTime });
    }
  }

  getCountUpText() {
    const { elapsedTime } = this.state;
    const h = Math.floor(elapsedTime / 3600);
    const m = Math.floor(elapsedTime % 3600 / 60);
    const s = Math.floor(elapsedTime % 60);
    return (
      (elapsedTime >= 3600 ? `${h}時間` : '') +
      (elapsedTime >= 60 ? `${m}分` : '') +
      `${s}秒`
    );
  }

  isElapsedTimeTimeCloseToMax() {
    const { elapsedTime } = this.state;
    return (MAX_LIVE_STREAMING_SECONDS - elapsedTime) < 60;
  }

  confirmUnload = (event) => {
    const { isLive, isPublishing } = this.state;
    if (isLive) {
      event.preventDefault();
      event.returnValue = 'レセプションを終了します。よろしいですか？';
      return;
    }
    if (isPublishing) {
      event.preventDefault();
      event.returnValue = '待機を終了します。よろしいですか？';
      return;
    }
  };

  addItem = (item) => {
    const { liveItems } = this.state;
    const index = liveItems.map((v) => v.id).indexOf(item.id);
    if (index === -1) {
      liveItems.push({ id: item.id, name: item.name, image: item.image });
      this.setState({ liveItems });
    }
  };

  removeItem = (item) => {
    const { liveItems } = this.state;
    const index = liveItems.map((v) => v.id).indexOf(item.id);
    if (index !== -1) {
      liveItems.splice(index, 1);
      this.setState({ liveItems });
    }
  };

  moveBackItem = (item) => {
    const { liveItems } = this.state;
    const index = liveItems.map((v) => v.id).indexOf(item.id);
    if (index > 0) {
      const element = liveItems.splice(index, 1);
      liveItems.splice(index - 1, 0, ...element);
      this.setState({ liveItems });
    }
  };

  moveNextItem = (item) => {
    const { liveItems } = this.state;
    const index = liveItems.map((v) => v.id).indexOf(item.id);
    if (index < liveItems.length - 1) {
      const element = liveItems.splice(index, 1);
      liveItems.splice(index + 1, 0, ...element);
      this.setState({ liveItems });
    }
  };

  toggleItemCTA = (item) => {
    const { liveItems, reception, isLive } = this.state;
    if (!isLive) {
      return;
    }
    if (!item.cta && MAX_CTA_ITEMS <= liveItems.filter((i) => !!i.cta).length) {
      const items = liveItems.filter((i) => !!i.cta);
      const ctaOffTarget = items.sort((a,b) => { return a.toggledAt > b.toggledAt ? 1 : -1}).shift();
      ctaOffTarget.cta = false;
      ctaOffTarget.toggledAt = null;
      db.collection('receptions').doc(reception.receptionId).collection('cta-events').add({
        created: firebase.firestore.FieldValue.serverTimestamp(),
        display: false,
        itemId: ctaOffTarget.id,
        uid: firebase.auth().currentUser.uid,
      });
    }

    const target = liveItems.find(v => v.id === item.id);
    if (target) {
      target.cta = !item.cta;
      target.toggledAt = new Date()
      this.setState({ liveItems });
    }
    db.collection('receptions').doc(reception.receptionId).collection('cta-events').add({
      created: firebase.firestore.FieldValue.serverTimestamp(),
      display: item.cta,
      itemId: item.id,
      uid: firebase.auth().currentUser.uid,
    });
  };

  resetItemCTA = () => {
    const { liveItems } = this.state;
    liveItems.forEach((i) => {
      i.cta = false;
      i.toggledAt = null;
    });
    this.setState({ liveItems })
  };

  onVolumeIcon = async () => {
    const {
      isVolumeOn,
    } = this.state;
    if (this.otSubscriber) {
      this.otSubscriber.setAudioVolume(isVolumeOn ? 0 : 100);
    }
    this.setState({ isVolumeOn: !isVolumeOn });
  };

  onMicrophoneIcon = async () => {
    const {
      isMicrophoneOn,
    } = this.state;
    if (this.otPublisher) {
      this.otPublisher.publishAudio(!isMicrophoneOn);
    }
    this.setState({ isMicrophoneOn: !isMicrophoneOn });
  };

  onDisconnect = async () => {
    const {
      isLive,
    } = this.state;

    if (isLive) {
      if (!window.confirm('レセプションが終了します。よろしいですか？')) {
        return;
      }
      await this.endReception();
    }
  };

  sendComment = () => {
    const { reception, receptionistName, receptionistText } = this.state;
    if (!reception || !reception.receptionId) {
      return;
    }
    db.collection('receptions').doc(reception.receptionId).collection('comments').add({
      name: receptionistName,
      isReceptionist: true,
      content: receptionistText,
      uid: reception.uid,
      receptionId: reception.receptionId,
      created: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }

  render() {
    const {
      isLoading,
      isOffline,
      isPublishing,
      isLive,
      isVolumeOn,
      isMicrophoneOn,
      rotated,
      shopIndex,
      shops,
      liveItems,
      calls,
    } = this.state;
    return (
      <div>
        <ReceptionistNav permission={this.props.permission}/>
        <div className="content live">
          <div className="broadcastingTitle">
            <h2>レセプション</h2>
            <div className="broadcastingTag">
              {isOffline && (
                <span className="broadcastingTagInner broadcastingOffline ml5">オフライン</span>
              )}
              {!isPublishing &&
                <span className="broadcastingTagInner broadcastingBefore ml5">待機前</span>
              }
              {isPublishing && !isLive &&
                <span className="broadcastingTagInner broadcastingPreview ml5">待機中</span>
              }
              {isPublishing && isLive &&
                <span className="broadcastingTagInner broadcastingStreaming ml5">レセプション中</span>
              }
            </div>
          </div>
          <div className="live_left">
            <Form>
              <div className="broadcastingMainInfo live_initialInfo">
                <div>
                  現在、待機中のお客様：<span style={{
                    fontSize: 32,
                    marginLeft: 10,
                    marginRight: 10,
                  }}>{calls.length}</span> 人
                </div>
                {ENABLE_ROTATION && <div className="mt10 mb10">
                  <Checkbox
                    name="rotated"
                    checked={rotated}
                    disabled={isLoading || isPublishing}
                    onChange={(e) => this.setState({ rotated: e.target.checked })}
                  >
                    カメラを時計回りに90度回転させて撮影
                  </Checkbox>
                </div>}
              </div>
            </Form>
            <div className="broadcastingItemList" style={{
              minHeight: ENABLE_CHAT ? 250 : 650,
            }}>
              <span className="live_titleLabel">
                提案中の商品
              </span>
              {ENABLE_CTA && isLive && (
                <small className="live_ctaLabel">
                  （レセプション画面左上にCTA表示中の商品 {
                    liveItems.filter((i) => !!i.cta).length
                  }/{
                    MAX_CTA_ITEMS
                  } 商品）
                </small>
              )}
              {!!liveItems.length ? (
                <ul>
                  {liveItems.map((item, index) => (
                    <li key={item.id} className="liveItem">
                      <img src={item.image} alt="item" />
                      <span>{item.name}</span>
                      {!isLive && (
                        <a onClick={() => this.removeItem(item)} href="#/">
                          <img src={closeIcon} alt="削除する" className="close"/>
                        </a>
                      )}
                      {!isLive && index > 0 &&
                        <a onClick={() => this.moveBackItem(item)} href="#/">
                          <img src={moveBackIcon} alt="前に移動する" className="moveBack"/>
                        </a>
                      }
                      {!isLive && index < liveItems.length - 1 &&
                        <a onClick={() => this.moveNextItem(item)} href="#/">
                          <img src={moveNextIcon} alt="次に移動する" className="moveNext"/>
                        </a>
                      }
                      {ENABLE_CTA && (
                        <a
                          className={
                            item.cta
                            ? "btn minibtn stockBtn blackBtn"
                            : "btn minibtn stockBtn grayBtn"
                          }
                          disabled={!isLive}
                          onClick={() => this.toggleItemCTA(item)}
                          href="#/"
                        >
                          {item.cta ? 'CTA ON' : 'CTA OFF'}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <small className="mt20 mb20 ml20 mr20">
                  お客様に提案する商品を「提案する商品」から選択してください。
                </small>
              )}
            </div>

            {ENABLE_CHAT && (
              <div className="broadcastingItemList" style={{
                minHeight: 650,
              }}>
                <span className="live_titleLabel">
                  チャット
                </span>
                <div>
                <Form className="mb10">
                    <FormGroup className="messages_fixedMessageFormGroup">
                      <FormControl
                        className="receptionst-name"
                        maxLength="10"
                        name="name"
                        onChange={(e) => this.setState({ receptionistName: e.target.value })}
                        placeholder="名前"
                        type="text"
                        value={this.state.receptionistName}
                      />
                      ：
                      <FormControl
                        className="receptionst-text"
                        maxLength="100"
                        name="text"
                        onChange={(e) => this.setState({ receptionistText: e.target.value })}
                        placeholder="コメント..."
                        type="text"
                        value={this.state.receptionistText}
                      />
                      <Button
                        className="normalBtn"
                        disabled={!(this.state.receptionistName && this.state.receptionistText)}
                        onClick={this.sendComment}
                      >
                        送信
                      </Button>
                    </FormGroup>
                  </Form>
                  {this.state.comments.map((comment, index) => (
                    <div key={index} className="reception-comment">
                      <span className="receptionist-name">{comment.name}:</span>
                      <div className="reception-content">
                        {comment.content}
                        <div className="reception-date">{moment(comment.created.toDate()).format('YYYY年M月D日 H:m')}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="live_right">
            <div className="positionRightupper">
              <div className="positionRightupperInner">
                <Form>
                  {!isPublishing &&
                    <div className="live_rightButtonsArea">
                      {isLoading && <span className="mr5 live_isLoadingLabel">読み込み中...</span>}
                      <div />
                      <Button
                        onClick={() => this.publish()}
                        disabled={isLoading}
                        className="normalBtn-strongColor ml10"
                      >
                        待機する
                      </Button>
                    </div>
                  }
                  {isPublishing && !isLive &&
                    <div className="live_rightButtonsArea">
                      {isLoading && <span className="mr5 live_isLoadingLabel">読み込み中...</span>}
                      {!isLoading &&
                        <Button
                          onClick={() => this.closePreview()}
                          className="btn normalBtn"
                        >
                          待機画面を閉じる
                        </Button>
                      }
                      <Button
                        onClick={() => this.startReception()}
                        disabled={isLoading || !calls.length}
                        className="btn normalBtn-strongColor ml10"
                      >
                        レセプションを始める
                      </Button>
                    </div>
                  }
                  {isPublishing && isLive &&
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                      <span className={`mr5 label label-${this.isElapsedTimeTimeCloseToMax() ? 'danger' : 'default'}`}>経過時間</span>
                      <span className={`mr5 ${this.isElapsedTimeTimeCloseToMax() ? 'text-danger' : ''}`}>{this.getCountUpText()}</span>
                      <Button
                        onClick={() => this.endReception()}
                        disabled={isLoading}
                        className="btn normalBtn ml10"
                      >
                        レセプションを終了する
                      </Button>
                    </div>
                  }
                </Form>
              </div>
            </div>
            <div id="hardware-setup" style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }} />
            <div className={isPublishing ? 'publisherArea' : ''} style={{
              display: isLoading ? 'none' : 'block',
            }}>
              <div id="publisher" className={`publisher${rotated ? 'Rotated' : ''}`} />
              <div id="subscriber" />
              {isLive && (
                <div style={{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  flexGrow: 0,
                  gap: 10,
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 10,
                }}>

                  <button
                    style={{
                      padding: '10px 0',
                      width: 80,
                      height: 60,
                      backgroundColor: 'transparent',
                      border: 'none',
                      borderRadius: 30,
                    }}
                    onClick={this.onVolumeIcon}
                  >
                    {isVolumeOn ? (
                      <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.4979 0.236741C13.2633 0.0918611 12.995 0.0106023 12.7194 0.000969081C12.4438 -0.00866418 12.1704 0.0536602 11.9263 0.181803L6.79993 2.96137C6.69172 3.02004 6.59613 3.09945 6.51861 3.19506C6.4411 3.29067 6.38317 3.40062 6.34814 3.51862C6.31312 3.63662 6.30168 3.76036 6.31447 3.88279C6.32727 4.00521 6.36405 4.12391 6.42273 4.23212C6.4814 4.34032 6.56081 4.43591 6.65642 4.51343C6.75203 4.59095 6.86198 4.64887 6.97998 4.6839C7.09798 4.71892 7.22172 4.73037 7.34415 4.71757C7.46657 4.70477 7.58527 4.66799 7.69348 4.60932L12.3761 2.07025V14.5983L5.61584 10.8739V4.23088L4.67888 4.24072L4.67834 4.24064L4.67773 4.24079L1.5625 4.2736C1.14822 4.27399 0.751012 4.43873 0.45807 4.73167C0.165127 5.02462 0.00038392 5.42182 0 5.8361V10.8361C0.000465082 11.042 0.0415214 11.2458 0.12082 11.4358C0.200118 11.6258 0.316102 11.7982 0.462135 11.9434C0.608169 12.0885 0.781385 12.2034 0.971873 12.2815C1.16236 12.3596 1.36638 12.3994 1.57226 12.3986L4.44166 12.3683L11.9537 16.505C12.1957 16.6261 12.4647 16.6832 12.735 16.6711C13.0053 16.659 13.268 16.5779 13.4982 16.4357C13.7284 16.2934 13.9184 16.0947 14.0501 15.8584C14.1819 15.622 14.2511 15.356 14.2511 15.0854V1.58805C14.252 1.31712 14.1833 1.05049 14.0513 0.81383C13.9194 0.577168 13.7289 0.378433 13.4979 0.236741ZM3.74084 10.5004L1.875 10.5199V6.14494L3.74084 6.1254V10.5004Z" fill="white"/>
                        <path d="M19.8585 1.61939C19.7016 1.49729 19.5085 1.43074 19.3097 1.43018H19.303C19.1586 1.43032 19.0163 1.4643 18.8874 1.52937C18.7585 1.59445 18.6467 1.68883 18.5608 1.80493C18.4145 2.00236 18.3514 2.2492 18.3848 2.49262C18.4182 2.73605 18.5456 2.95673 18.7397 3.10743C19.1817 3.48222 19.5604 3.92572 19.8615 4.4209C20.5837 5.59752 20.9594 6.95397 20.9455 8.33448C20.9674 9.71131 20.5944 11.0656 19.8706 12.2371C19.5686 12.737 19.186 13.1837 18.7384 13.5591C18.5828 13.6777 18.4682 13.842 18.4106 14.0289C18.3531 14.2159 18.3554 14.4162 18.4174 14.6018C18.4794 14.7874 18.5979 14.9489 18.7562 15.0638C18.9146 15.1787 19.1049 15.2411 19.3006 15.2424H19.3128C19.5138 15.2415 19.7089 15.1746 19.8682 15.052C20.0434 14.8897 20.213 14.72 20.373 14.5466C21.1888 13.6644 21.8227 12.6301 22.2385 11.5027C22.6542 10.3753 22.8436 9.17699 22.7958 7.97634C22.748 6.77568 22.464 5.59623 21.96 4.50544C21.4559 3.41466 20.7418 2.43394 19.8584 1.61939H19.8585Z" fill="white"/>
                        <path d="M16.7805 4.344C16.6028 4.18802 16.371 4.10805 16.1349 4.12129C15.8989 4.13453 15.6774 4.23993 15.5183 4.4148C15.3584 4.59353 15.2746 4.8276 15.2846 5.06719C15.2947 5.30679 15.3978 5.53302 15.5721 5.69776C16.2631 6.38351 16.6922 7.28964 16.7848 8.2588C16.771 8.77663 16.6531 9.28637 16.438 9.75762C16.2229 10.2289 15.9151 10.652 15.533 11.0017C15.4082 11.1295 15.3237 11.291 15.2899 11.4664C15.2561 11.6417 15.2746 11.8231 15.3429 11.9881C15.4113 12.1531 15.5266 12.2943 15.6746 12.3944C15.8225 12.4944 15.9965 12.5488 16.1751 12.5508H16.1769C16.2971 12.5508 16.416 12.5264 16.5264 12.479C16.6368 12.4315 16.7363 12.3621 16.819 12.2749C17.3781 11.7502 17.8233 11.116 18.1267 10.4119C18.4302 9.70773 18.5855 8.94866 18.5829 8.1819C18.4825 6.7224 17.8395 5.35333 16.7805 4.344Z" fill="white"/>
                      </svg>
                    ) : (
                      <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.4979 0.23675C13.2633 0.091864 12.995 0.0106023 12.7194 0.000969049C12.4438 -0.00866425 12.1704 0.0536631 11.9263 0.181812L6.79991 2.96137C6.69171 3.02005 6.59612 3.09946 6.5186 3.19507C6.44108 3.29068 6.38316 3.40063 6.34813 3.51863C6.31311 3.63663 6.30166 3.76037 6.31446 3.88279C6.32726 4.00522 6.36404 4.12392 6.42271 4.23213C6.54121 4.45066 6.74166 4.61317 6.97997 4.68391C7.09797 4.71893 7.22171 4.73037 7.34413 4.71758C7.46655 4.70478 7.58526 4.668 7.69346 4.60932L12.3761 2.07026V14.5983L5.61583 10.8739V4.23089L4.67888 4.24073L4.67834 4.24065L4.67773 4.2408L1.5625 4.27361C1.14822 4.274 0.751012 4.43874 0.45807 4.73168C0.165127 5.02462 0.00038392 5.42183 0 5.83611V10.8361C0.000465082 11.042 0.0415214 11.2458 0.12082 11.4358C0.200118 11.6258 0.316102 11.7983 0.462136 11.9434C0.608169 12.0885 0.781385 12.2034 0.971873 12.2815C1.16236 12.3596 1.36638 12.3994 1.57226 12.3986L4.44168 12.3683L11.9537 16.5051C12.1957 16.6261 12.4647 16.6832 12.735 16.6711C13.0053 16.659 13.268 16.5779 13.4982 16.4357C13.7284 16.2934 13.9184 16.0947 14.0502 15.8584C14.1819 15.6221 14.2511 15.356 14.2511 15.0854V1.58806C14.2521 1.31712 14.1833 1.0505 14.0514 0.813837C13.9194 0.577175 13.7289 0.37844 13.4979 0.23675ZM1.87499 6.14495L3.74083 6.12541V10.5004L1.87499 10.5199V6.14495Z" fill="white"/>
                        <path d="M23.4562 10.5903L21.2022 8.33693L23.4569 6.08351C23.6563 5.88408 23.7684 5.61359 23.7684 5.33156C23.7684 5.04952 23.6563 4.77904 23.4569 4.57961C23.2575 4.38018 22.987 4.26814 22.7049 4.26814C22.4229 4.26814 22.1524 4.38018 21.953 4.57961L19.6989 6.83424L17.4461 4.58083C17.3477 4.48127 17.2305 4.40215 17.1013 4.34802C16.9722 4.29389 16.8336 4.26581 16.6936 4.26542C16.5535 4.26502 16.4148 4.2923 16.2853 4.34569C16.1559 4.39908 16.0382 4.47754 15.9392 4.57654C15.8401 4.67554 15.7616 4.79314 15.7082 4.92258C15.6547 5.05202 15.6274 5.19075 15.6277 5.33079C15.6281 5.47082 15.6561 5.60942 15.7102 5.73859C15.7642 5.86777 15.8433 5.98499 15.9428 6.08351L18.1969 8.33693L15.9447 10.5879C15.7944 10.7355 15.6913 10.9244 15.6488 11.1307C15.6062 11.337 15.6259 11.5513 15.7055 11.7464C15.7851 11.9414 15.9209 12.1083 16.0957 12.2259C16.2704 12.3435 16.4762 12.4065 16.6869 12.4068C16.9709 12.4054 17.243 12.2928 17.4449 12.093L19.6989 9.83837L21.953 12.093C22.1557 12.2858 22.4248 12.3933 22.7046 12.3933C22.9844 12.3933 23.2535 12.2858 23.4563 12.093C23.555 11.9944 23.6332 11.8772 23.6867 11.7483C23.7401 11.6194 23.7676 11.4812 23.7676 11.3417C23.7676 11.2021 23.7401 11.0639 23.6867 10.935C23.6332 10.8061 23.555 10.689 23.4563 10.5903L23.4562 10.5903Z" fill="#E2592C"/>
                      </svg>
                    )}
                    <span style={{
                      display: 'block',
                      fontSize: '8px',
                      color: 'white',
                      marginTop: '10px'
                    }} >{isVolumeOn ? 'スピーカーをオフ' : 'スピーカーをオン' }</span>
                  </button>
                  <button
                    style={{
                      padding: '10px 0',
                      width: 80,
                      height: 60,
                      backgroundColor: 'transparent',
                      border: 'none',
                      borderRadius: 30,
                    }}
                    onClick={this.onMicrophoneIcon}
                  >
                    {isMicrophoneOn ? (
                      <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.83743 11.4524C4.92374 11.397 4.99828 11.3252 5.05681 11.2409C5.11533 11.1567 5.15669 11.0618 5.17851 10.9616C5.20034 10.8614 5.2022 10.7578 5.184 10.6569C5.1658 10.556 5.12788 10.4596 5.07243 10.3733C4.82009 9.98044 4.68638 9.52314 4.6873 9.05619V3.96343C4.67973 3.65087 4.73476 3.33995 4.84914 3.04897C4.96352 2.75799 5.13495 2.49283 5.35333 2.26909C5.57172 2.04535 5.83265 1.86755 6.12078 1.74615C6.4089 1.62476 6.7184 1.56222 7.03105 1.56222C7.34371 1.56222 7.6532 1.62476 7.94133 1.74615C8.22945 1.86755 8.49039 2.04535 8.70877 2.26909C8.92716 2.49283 9.09859 2.75799 9.21297 3.04897C9.32735 3.33995 9.38238 3.65087 9.3748 3.96343V9.05618C9.38169 9.68529 9.13884 10.2915 8.69949 10.7418C8.26014 11.1921 7.66014 11.4499 7.03105 11.4585C6.82385 11.4585 6.62514 11.5408 6.47863 11.6873C6.33211 11.8339 6.2498 12.0326 6.2498 12.2398C6.2498 12.447 6.33211 12.6457 6.47863 12.7922C6.62514 12.9387 6.82385 13.021 7.03105 13.021C8.07444 13.012 9.07166 12.5895 9.80396 11.8463C10.5363 11.103 10.9438 10.0996 10.9373 9.05618V3.96343C10.9448 3.44568 10.8494 2.9316 10.6564 2.45107C10.4635 1.97055 10.177 1.53318 9.81348 1.16438C9.45001 0.795584 9.01684 0.502725 8.53917 0.302832C8.0615 0.102939 7.54886 0 7.03105 0C6.51325 0 6.0006 0.102939 5.52294 0.302832C5.04527 0.502725 4.6121 0.795584 4.24863 1.16438C3.88515 1.53318 3.59862 1.97055 3.40569 2.45107C3.21276 2.9316 3.11728 3.44568 3.1248 3.96343V9.05618C3.12388 9.82262 3.34361 10.5731 3.75774 11.218C3.87011 11.392 4.04682 11.5143 4.24918 11.5582C4.45153 11.6022 4.66306 11.5641 4.83743 11.4524Z" fill="white"/>
                        <path d="M13.2812 8.50812C13.0741 8.50831 12.8755 8.59068 12.729 8.73715C12.5826 8.88362 12.5002 9.08223 12.5 9.28937C12.5 10.7398 11.9238 12.1308 10.8982 13.1564C9.87265 14.1819 8.48165 14.7581 7.03125 14.7581C5.58085 14.7581 4.18985 14.1819 3.16426 13.1564C2.13867 12.1308 1.5625 10.7398 1.5625 9.28937C1.5625 9.08217 1.48019 8.88345 1.33368 8.73694C1.18716 8.59043 0.98845 8.50812 0.78125 8.50812C0.57405 8.50812 0.375336 8.59043 0.228823 8.73694C0.08231 8.88345 0 9.08217 0 9.28937C0.0115649 11.0153 0.653087 12.6776 1.804 13.9638C2.95491 15.2501 4.53595 16.0717 6.25 16.2742V18.4299C6.25 18.6371 6.33231 18.8359 6.47882 18.9824C6.62534 19.1289 6.82405 19.2112 7.03125 19.2112C7.23845 19.2112 7.43716 19.1289 7.58368 18.9824C7.73019 18.8359 7.8125 18.6371 7.8125 18.4299V16.2742C9.52654 16.0717 11.1076 15.2501 12.2585 13.9638C13.4094 12.6776 14.0509 11.0153 14.0625 9.28937C14.0623 9.08223 13.9799 8.88362 13.8335 8.73715C13.687 8.59068 13.4884 8.50831 13.2812 8.50812Z" fill="white"/>
                      </svg>
                    ) : (
                      <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.38447 11.5774C6.52482 11.5772 6.66256 11.5393 6.78318 11.4675C6.90381 11.3958 7.00285 11.2928 7.06997 11.1696C7.1371 11.0463 7.16982 10.9073 7.16465 10.7671C7.15948 10.6268 7.11662 10.4905 7.0406 10.3725C6.78842 9.98052 6.65489 9.52398 6.65608 9.05785V3.96515C6.64837 3.6525 6.70327 3.34141 6.81759 3.05031C6.93191 2.75921 7.10334 2.49398 7.32174 2.27013C7.54014 2.04627 7.80114 1.86836 8.08934 1.7469C8.37753 1.62544 8.68708 1.56288 8.99983 1.56288C9.31257 1.56288 9.62213 1.62544 9.91032 1.7469C10.1985 1.86836 10.4595 2.04627 10.6779 2.27013C10.8963 2.49398 11.0677 2.75921 11.1821 3.05031C11.2964 3.34141 11.3513 3.6525 11.3436 3.96515V9.05792C11.3504 9.68691 11.1075 10.2929 10.6681 10.743C10.2288 11.1932 9.6288 11.4507 8.99983 11.459C8.79263 11.459 8.5939 11.5413 8.44738 11.6879C8.30087 11.8344 8.21858 12.0331 8.21858 12.2403C8.21858 12.4475 8.30087 12.6462 8.44738 12.7927C8.5939 12.9392 8.79263 13.0215 8.99983 13.0215C10.043 13.0126 11.0401 12.5903 11.7724 11.8473C12.5047 11.1043 12.9124 10.1011 12.9061 9.05792V3.96515C12.9138 3.44725 12.8185 2.93296 12.6257 2.45224C12.4329 1.97152 12.1464 1.53391 11.7829 1.16493C11.4194 0.795953 10.9862 0.502964 10.5084 0.302963C10.0306 0.102962 9.51778 0 8.99983 0C8.48187 0 7.96913 0.102962 7.49134 0.302963C7.01356 0.502964 6.58027 0.795953 6.21678 1.16493C5.85328 1.53391 5.56679 1.97152 5.37396 2.45224C5.18113 2.93296 5.08583 3.44725 5.09358 3.96515V9.05792C5.0924 9.82448 5.31238 10.5751 5.72712 11.2198C5.79795 11.3297 5.89524 11.4201 6.0101 11.4825C6.12496 11.545 6.25371 11.5776 6.38447 11.5774V11.5774Z" fill="white"/>
                        <path d="M15.25 8.66528C15.1679 8.66524 15.0866 8.68135 15.0107 8.71274C14.9349 8.74413 14.866 8.79019 14.808 8.84824C14.7499 8.90628 14.7038 8.97518 14.6725 9.05103C14.6411 9.12687 14.625 9.20819 14.625 9.29028C14.625 10.7821 14.0324 12.2129 12.9775 13.2678C11.9226 14.3227 10.4918 14.9153 9 14.9153C7.50816 14.9153 6.07738 14.3227 5.02249 13.2678C3.9676 12.2129 3.375 10.7821 3.375 9.29028C3.375 9.12452 3.30918 8.96552 3.19197 8.84831C3.07476 8.7311 2.91576 8.66528 2.75 8.66528C2.58424 8.66528 2.42524 8.7311 2.30803 8.84831C2.19082 8.96552 2.125 9.12452 2.125 9.29028C2.1274 11.0044 2.76941 12.656 3.92538 13.9217C5.08136 15.1874 6.66809 15.9762 8.375 16.1336V18.431C8.375 18.5967 8.44082 18.7557 8.55803 18.873C8.67524 18.9902 8.83424 19.056 9 19.056C9.16576 19.056 9.32476 18.9902 9.44197 18.873C9.55918 18.7557 9.625 18.5967 9.625 18.431V16.1336C11.3319 15.9762 12.9186 15.1874 14.0746 13.9217C15.2306 12.656 15.8726 11.0044 15.875 9.29028C15.875 9.20819 15.8589 9.12687 15.8275 9.05103C15.7962 8.97518 15.7501 8.90628 15.692 8.84824C15.634 8.79019 15.5651 8.74413 15.4893 8.71274C15.4134 8.68135 15.3321 8.66524 15.25 8.66528V8.66528Z" fill="white"/>
                        <path d="M0.851113 18.1032C0.696487 18.1033 0.545282 18.0575 0.416695 17.9717C0.288109 17.8858 0.187908 17.7637 0.128762 17.6208C0.069616 17.4779 0.0541776 17.3207 0.0844351 17.1691C0.114693 17.0174 0.189296 16.8782 0.298745 16.769L16.597 0.471285C16.7438 0.325544 16.9424 0.24395 17.1493 0.244387C17.3561 0.244823 17.5544 0.327291 17.7006 0.47365C17.8468 0.620009 17.929 0.818385 17.9292 1.02525C17.9294 1.23212 17.8476 1.43059 17.7017 1.57724L1.40348 17.8748C1.33102 17.9475 1.24491 18.005 1.15011 18.0442C1.05531 18.0834 0.953694 18.1035 0.851113 18.1032Z" fill="#E2592C"/>
                      </svg>
                    )}
                    <span style={{
                      display: 'block',
                      fontSize: '8px',
                      color: 'white',
                      marginTop: '8px'
                    }} >{isMicrophoneOn ? 'マイクをオン' : 'マイクをオフ' }</span>
                  </button>
                  <button
                    style={{
                      padding: '10px 0',
                      width: 80,
                      height: 60,
                      backgroundColor: 'transparent',
                      border: 'none',
                      borderRadius: 30,
                    }}
                    onClick={this.onDisconnect}
                  >
                    <svg width="22" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.29451 10.111C2.84724 10.1102 2.40932 9.98287 2.03132 9.74377C1.65332 9.50467 1.35065 9.16354 1.15826 8.75976C0.789382 8.06648 0.455516 7.35513 0.15792 6.62839C-0.0727464 5.89901 -0.0501622 5.11309 0.222008 4.39816C0.436501 3.82577 0.778617 3.30979 1.22237 2.88941C3.00582 1.10719 6.58676 0 10.5699 0H10.5767C15.6212 0 19.7564 1.69556 20.8666 4.22C20.9665 4.45238 21.0261 4.70005 21.043 4.95243C21.1174 6.21059 20.796 7.46048 20.1238 8.52664C20.0695 8.62308 20.0219 8.70609 19.9871 8.77689C19.7155 9.3377 19.2334 9.76849 18.6457 9.97541C18.0579 10.1823 17.4122 10.1486 16.8493 9.88163L14.1851 8.61698C13.6203 8.34769 13.1852 7.8656 12.9751 7.27626C12.7649 6.68691 12.7968 6.03831 13.0638 5.47244C13.153 5.28599 13.3125 5.14249 13.5073 5.07336C13.7021 5.00422 13.9163 5.01508 14.1031 5.10356C14.2899 5.19204 14.4341 5.35092 14.504 5.54543C14.5739 5.73995 14.5639 5.95424 14.4762 6.14139C14.3858 6.33288 14.3749 6.55238 14.4459 6.75186C14.517 6.95134 14.6641 7.11457 14.8552 7.20584L17.5188 8.47049C17.7094 8.56101 17.9281 8.57241 18.1271 8.50219C18.3261 8.43197 18.4892 8.28585 18.5808 8.09574C18.6296 7.99564 18.6913 7.88574 18.7633 7.75882C19.2818 6.96109 19.5345 6.01975 19.4853 5.06961C19.4808 4.9938 19.4641 4.9192 19.4359 4.84866C18.5985 2.94436 14.8723 1.56253 10.5766 1.56253H10.5705C7.04026 1.56253 3.8054 2.51713 2.32773 3.99418C2.02829 4.2782 1.79763 4.62681 1.65329 5.01346C1.53407 5.39118 1.53364 5.79638 1.65205 6.17435C1.68134 6.24636 1.94746 6.82254 2.56579 8.08109C2.61003 8.177 2.6728 8.26321 2.7505 8.33476C2.8282 8.4063 2.91928 8.46177 3.0185 8.49796C3.11772 8.53416 3.22313 8.55036 3.32864 8.54565C3.43416 8.54093 3.5377 8.51539 3.6333 8.47049L6.52454 7.0972C6.65499 7.03397 6.75532 6.92196 6.80386 6.78537C6.8524 6.64877 6.84525 6.49856 6.78395 6.3672L6.55995 5.89601C6.48152 5.73113 6.44001 5.55111 6.43832 5.36853C6.43664 5.18595 6.47481 5.0052 6.55018 4.83889C6.62347 4.67525 6.73163 4.5296 6.86711 4.41215C7.00259 4.2947 7.1621 4.20828 7.33448 4.15895C8.88278 3.72709 10.5015 3.60758 12.0964 3.80739C12.1982 3.82021 12.2965 3.85295 12.3857 3.90376C12.4748 3.95456 12.5531 4.02242 12.616 4.10347C12.6789 4.18451 12.7252 4.27716 12.7523 4.37612C12.7794 4.47507 12.7868 4.57839 12.7739 4.68019C12.7454 4.88458 12.6382 5.06977 12.4752 5.19631C12.3122 5.32285 12.1062 5.38076 11.9011 5.35769C10.6426 5.20091 9.36614 5.27076 8.13222 5.56394L8.19508 5.69576C8.43476 6.20147 8.46404 6.78161 8.27649 7.30888C8.08895 7.83615 7.69991 8.26749 7.19472 8.50827L4.30347 9.88157C3.98845 10.0323 3.64373 10.1107 3.29451 10.111Z" fill="white"/>
                    </svg>
                    <span style={{
                      display: 'block',
                      fontSize: '8px',
                      color: 'white',
                      marginTop: '10px'
                    }} >電話を終了</span>
                  </button>
                </div>
              )}
            </div>
          </div>
          {!isLive && (
            <div className="broadcastingItemList">
              <span className="live_titleLabel">
                提案する商品
              </span>
              <div className="mt20 ml20 mr20">
                <div>
                  <ControlLabel>ショップの選択</ControlLabel>
                </div>
                <div>
                  {shops.length > 0 && (
                    <DropdownButton
                      id="shop"
                      title={shops[shopIndex].name}
                    >
                      {shops.map((shop, i) => (
                        <MenuItem
                          key={i}
                          eventKey={i}
                          active={i === shopIndex}
                          onSelect={(i) => this.setState({ shopIndex: i })}
                        >
                          {shop.name}
                        </MenuItem>
                      ))}
                    </DropdownButton>
                  )}
                </div>
                <div>
                  <ControlLabel>商品の選択</ControlLabel>
                </div>
                <div>
                  {shops.length > 0 && (
                    <ItemSearch shopId={shops[shopIndex].id} onAddItem={this.addItem} />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
